import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { DashboardSettingPayload, UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateUserDashboardSettings = async (formData: DashboardSettingPayload): Promise<UserSettingsResponse> => {
  const response = await CustomAxios.put(`user-dashboard-settings`, { settings: formData });
  const { data } = response;
  return data;
};

export function useUpdateUserDashboardSettings() {
  return useMutation({
    mutationFn: (formData: DashboardSettingPayload) => updateUserDashboardSettings(formData),
    onSuccess: () => {
      // fetch the user dashboardSettings again after update
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserSettings] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: UserSettingsResponse = err.response.data as UserSettingsResponse;
        queryClient.setQueryData([queryKeys.currentUserSettings], data);
      }
    },
  });
}
